var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgshield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 447,
    height: 491,
    viewBox: "0 0 447 491",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    clipPath: "url(#clip0_1_431)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.511 70.5939C275.292 90.4484 219.214 34.3852 211.683 26.15C211.683 26.15 211.562 25.3441 211.237 25.6453C210.936 25.3206 210.751 26.1053 210.751 26.1053C202.519 33.6527 141.742 84.5699 27.7064 54.5758C27.7064 54.5758 0.929119 260.91 64.3059 348.355C132.009 441.742 191.303 471.687 191.623 471.47C191.912 471.713 254.089 447.632 329.223 359.919C399.549 278.027 391.511 70.5939 391.511 70.5939Z",
    fill: "#23A8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.649 91.1638C268.22 108.721 217.289 58.7961 210.447 51.4496C210.447 51.4496 210.34 50.7424 210.046 51.0222C209.782 50.7254 209.602 51.4254 209.602 51.4254C202.2 58.1244 147.02 103.422 43.5093 76.6368C43.5093 76.6368 19.3502 260.256 76.9415 338.21C138.442 421.464 191.995 453.046 192.268 452.854C192.536 453.066 249.229 426.75 317.354 348.788C381.17 275.833 373.649 91.1638 373.649 91.1638Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.918 69.5602C208.918 69.5602 209.096 68.8437 209.378 69.1545C209.67 68.8582 209.8 69.6123 209.8 69.6123C216.823 77.1503 268.252 127.589 374.316 112.123C374.644 93.3017 374.162 81.4989 374.162 81.4989C268.716 99.0585 217.785 49.1336 210.962 41.8011C210.962 41.8011 210.853 41.0774 210.558 41.3572C210.279 41.063 210.115 41.7605 210.115 41.7605C202.713 48.4594 147.533 93.7569 44.022 66.9719C44.022 66.9719 42.4239 78.701 41.1095 97.4521C145.478 122.224 201.163 76.4806 208.918 69.5602Z",
    fill: "#23A8FA"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M340.5 141.016C260.828 154.695 213.054 113.899 207.898 108.25C207.898 108.25 207.816 107.707 207.594 107.909C207.392 107.687 207.255 108.229 207.255 108.229C201.625 113.399 150.976 149.688 72.7953 129.148C72.7953 129.148 63.4044 269.198 106.875 329.229C153.287 393.257 193.94 413.796 194.153 413.647C194.361 413.8 236.99 397.306 288.511 337.202C336.707 280.929 340.5 141.016 340.5 141.016Z",
    fill: "#23A8FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_431"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 385.174,
    height: 438.034,
    fill: "white",
    transform: "translate(0 57.3516) rotate(-8.56303)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgshield);
export default __webpack_public_path__ + "static/media/bgshield.70bc78880657abf02644551041bbf4a9.svg";
export { ForwardRef as ReactComponent };